"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbLeftColumn = exports._SbLeftColumn = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _value = require("../../skybase-core/utils/value");

var _logger = require("../../skybase-core/utils/logger");

var _shapes = require("../../skybase-core/shapes");

var _reactRedux = require("react-redux");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _SbLeftColumn = /*#__PURE__*/function (_PureComponent) {
  _inherits(_SbLeftColumn, _PureComponent);

  var _super = _createSuper(_SbLeftColumn);

  function _SbLeftColumn(props) {
    var _this;

    _classCallCheck(this, _SbLeftColumn);

    _this = _super.call(this, props);
    var isCollapsed = props.leftColumn.isCollapsed;

    if (!(0, _value.isNullOrUndefined)(isCollapsed)) {
      (0, _logger.deprecate)('[SbLeftColumn] property `leftColumn` has been removed. Please declare the `isCollapsed` state with the prop `collapsed`.');
    }

    return _this;
  }

  _createClass(_SbLeftColumn, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          id = _this$props.id,
          hidden = _this$props.hidden,
          style = _this$props.style,
          collapsed = _this$props.collapsed;
      var leftColumnClassName = (0, _classnames.default)({
        'left-column-collapsed': collapsed
      }, 'left-column', 'fl-shrink-0', 'fl-col', className);

      if (hidden) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: leftColumnClassName,
        id: id,
        style: style
      }, children);
    }
  }]);

  return _SbLeftColumn;
}(_react.PureComponent);

exports._SbLeftColumn = _SbLeftColumn;

_defineProperty(_SbLeftColumn, "propTypes", {
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  leftColumn: _propTypes.default.shape({
    isCollapsed: _propTypes.default.bool
  }),
  children: _shapes.PropTypeChildren.isRequired,
  style: _propTypes.default.object,
  // eslint-disable-line
  collapsed: _propTypes.default.bool.isRequired,
  hidden: _propTypes.default.bool.isRequired,
  // these props are used in mapStateToProps and are mapped into `collapsed` and `hidden`
  isCollapsed: _propTypes.default.bool,
  // eslint-disable-line react/no-unused-prop-types
  isHidden: _propTypes.default.bool // eslint-disable-line react/no-unused-prop-types

});

_defineProperty(_SbLeftColumn, "defaultProps", {
  className: null,
  id: null,
  style: null,
  isCollapsed: false,
  isHidden: false,
  leftColumn: {
    isCollapsed: null
  }
});

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$leftColumn;

  var leftColumnState = state[_constants.SB_LEFT_COLUMN_STATE_NAME];
  var collapsed = !!(ownProps.isCollapsed || (leftColumnState === null || leftColumnState === void 0 ? void 0 : leftColumnState.isCollapsed) || ((_ownProps$leftColumn = ownProps.leftColumn) === null || _ownProps$leftColumn === void 0 ? void 0 : _ownProps$leftColumn.isCollapsed));
  var hidden = !!(ownProps.isHidden || (leftColumnState === null || leftColumnState === void 0 ? void 0 : leftColumnState.isHidden));
  return {
    collapsed: collapsed,
    hidden: hidden
  };
};

var SbLeftColumn = (0, _reactRedux.connect)(mapStateToProps)(_SbLeftColumn);
exports.SbLeftColumn = SbLeftColumn;
//# sourceMappingURL=sb-left-column.js.map